export {
  now,
  timer,
  timerFlush
} from "./timer";

export {
  default as timeout
} from "./timeout";

export {
  default as interval
} from "./interval";



//////////////////
// WEBPACK FOOTER
// ./~/d3-timer/src/index.js
// module id = 9fCz
// module chunks = 0